import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../utils/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-backgroundbadge text-primary-foreground",
        highlight: "border-transparent bg-tag1 text-primary-foreground",
        articleTag: "border-transparent bg-white text-primary",
        info: "border-transparent bg-tag3 text-primary-foreground",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        gray: "border-transparent bg-slate-300 text-secondary-foreground",
        accent: "border-transparent bg-accent text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        webinarLive: "px-3 py-0 text-xs font-normal bg-slate-200 text-primary-foreground",
        white: "border-transparent bg-white text-primary shadow hover:bg-primary/10",
        semitransparent: "border-transparent bg-black/30 text-primary-foreground"
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, ...props }: BadgeProps): JSX.Element => {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
